import { Injectable } from '@angular/core';
import { PlantEndpoint } from '../../../../constants';
import { PlantExternalId, PlantExtIdsRequestModel } from '../models';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlantExternalIdsService {
  constructor(private http: WrapperHttpService) {}

  getAvailableExternalIds(params: PlantExtIdsRequestModel): Observable<PlantExternalId[]> {
    return this.http.get<PlantExternalId[]>(`${API_URL}${PlantEndpoint.Base}${PlantEndpoint.ExtIds}`, {
      params,
    });
  }
}
